export const UPDATE_REPLY_MESSAGE_ID = 'UPDATE_REPLY_MESSAGE_ID' as const

export const updateReplyMessageIdAction = (
  messageId: number | null = null,
  // В сценарии ответа на определенное фото из группы фото
  photoId: number | null = null
) => ({
  type: UPDATE_REPLY_MESSAGE_ID,
  messageId,
  photoId,
})
